import { Link } from 'react-router-dom';
import './ui.css';

/**
 * One button, three renderings — <button>, react-router <Link>, or <a>.
 *
 * External URLs must never go through react-router's <Link>: it treats an
 * absolute URL as an internal path. `href` renders a real anchor instead.
 */
const Button = ({
  children,
  to,
  href,
  variant = 'primary',
  size,
  block = false,
  icon = null,
  iconPosition = 'end',
  className = '',
  external = false,
  ...rest
}) => {
  const classes = [
    'btn',
    `btn--${variant}`,
    size ? `btn--${size}` : '',
    block ? 'btn--block' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {icon && iconPosition === 'start' && (
        <span className="btn__icon" aria-hidden="true">{icon}</span>
      )}
      <span>{children}</span>
      {icon && iconPosition === 'end' && (
        <span className="btn__icon" aria-hidden="true">{icon}</span>
      )}
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {content}
      </Link>
    );
  }

  if (href) {
    const externalProps = external
      ? { target: '_blank', rel: 'noopener noreferrer' }
      : {};
    return (
      <a href={href} className={classes} {...externalProps} {...rest}>
        {content}
        {external && <span className="sr-only"> (opens in a new tab)</span>}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {content}
    </button>
  );
};

export default Button;
